import { render, staticRenderFns } from "./GlobalSnackBar.vue?vue&type=template&id=84b4f2d4&"
import script from "./GlobalSnackBar.vue?vue&type=script&lang=js&"
export * from "./GlobalSnackBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports